import { useEffect } from 'react';
import { IAddress, IPickup } from '../types/FundraiserTypes.ts';
import { ICatalogItem } from '../types/CatalogTypes.ts';

export interface ISubmissionForm extends IAddress {
    name: string;
    contactName: string;
    phoneNumber: string;
    email: string;
    startDate: string;
    deliveryDate: string;
    catalog: string;
    pickups: IPickup[];
    cashPayment: boolean;
    transferPayment: boolean;
    cashPaymentNotes: string;
    transferPaymentNotes: string;
    transferPaymentAccount: string;
    referralSource: string;
    referralSourceOther: string;
}

export interface IAdminFundraiserRequest {
    catalog: string;
    customPricing: boolean;
    items: ICatalogItem[];
    commission: number;
    endDate: string;
}

export function CreateFundraiserRequest() {
    // Redirect to raised.nz
    useEffect(() => {
        window.location.href = 'https://raised.nz/w/pasta-vera';
    }, []);

    // Show loading while redirecting
    return (
        <div className='index-wrapper d-flex justify-content-center align-items-center'>
            <div className='col-lg-4 col-md-8'>
                <div className='card text-center p-4'>
                    <h4>Redirecting...</h4>
                </div>
            </div>
        </div>
    );
}
